export class SendOTPRequest {
  public channel: string;
  public userContact: string;
}

export class VerifyOTPRequest {
  public userContact: string;
  public accessCode: string
}
